<template>
	<div class="organization-restricted-access-panel">
		<div class="organization-restricted-access-panel__body">
			<font-awesome-icon
				class="organization-restricted-access-panel__icon"
				:icon="['fal', 'lock']"
				aria-hidden="true"
			/>
			<h3 class="organization-restricted-access-panel__title">
				{{ copy.title }}
			</h3>
			<p class="organization-restricted-access-panel__description">
				{{ copy.description }}
			</p>

			<div class="organization-restricted-access-panel__admins">
				<div
					v-for="admin in admins"
					:key="admin.id"
					class="organization-restricted-access-panel__admin-card"
				>
					<p class="organization-restricted-access-panel__admin-role">
						{{ admin.roleLabel }}
					</p>
					<div
						class="organization-restricted-access-panel__admin-body"
					>
						<div
							class="organization-restricted-access-panel__admin-avatar"
							:class="
								admin.isPrimary
									? 'organization-restricted-access-panel__admin-avatar--primary'
									: 'organization-restricted-access-panel__admin-avatar--secondary'
							"
							aria-hidden="true"
						>
							{{ getAdminInitials(admin.name) }}
						</div>
						<div>
							<p
								class="organization-restricted-access-panel__admin-name"
							>
								{{ admin.name }}
							</p>
							<p
								class="organization-restricted-access-panel__admin-email"
							>
								{{ admin.email }}
							</p>
						</div>
					</div>
				</div>
			</div>

			<p
				v-if="showNote"
				class="organization-restricted-access-panel__note"
			>
				<strong>{{ copy.notePrefix }}</strong>
				{{ copy.noteBody }}
			</p>
		</div>
	</div>
</template>

<script>
import { ORGANIZATION_RESTRICTED_ACCESS_STRINGS } from '@/config/settingsConstants'

/**
 * Restricted access panel shown when organization settings require Org Admin role.
 */
export default {
	methods: {
		getAdminInitials(name) {
			if (!name || typeof name !== 'string') {
				return '?'
			}

			const parts = name
				.trim()
				.split(/\s+/)
				.filter(Boolean)

			if (parts.length === 0) {
				return '?'
			}

			if (parts.length === 1) {
				return parts[0].slice(0, 2).toUpperCase()
			}

			return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
		},
	},
	name: 'OrganizationRestrictedAccessPanel',

	props: {
		admins: {
			default: () => [],
			type: Array,
		},

		copy: {
			default: () => ORGANIZATION_RESTRICTED_ACCESS_STRINGS,
			type: Object,
		},

		showNote: {
			default: false,
			type: Boolean,
		},
	},
}
</script>
